export default "__VITE_ASSET__7Y0Ppixb__"